import PDSFooter from '@pds-react/enterpriseFooter';
import '@pds-react/enterpriseFooter/dist/enterpriseFooter.min.css';
import '@pds-react/core/dist/core.min.css';
import { LocalizationContext } from '../app';
import React, { useContext } from 'react';

const Footer: React.FunctionComponent = () => {
  // TODO Determine lang and display correct footer

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const localization = useContext(LocalizationContext)!;

  let lang = 'en';
  if (localization.resolvedLanguage === 'es') {
    lang = 'es';
  }

  return (
    <PDSFooter
      key={lang}
      contactUsUrl="https://www.principal.com/contact-us"
      phoneNumber={'866-237-9742'}
      variant="dark"
      hideLinks={['espanol']}
      lang={lang}
    />
  );
};

export default Footer;
